// Common mutation options that trigger a refetch of a membership's money maps.
import { useQueryClient } from '@tanstack/react-query';

import type { CommonMutationOptions } from '../../common/types/Common';
import type { MembershipDetails } from '../../entities/entityTypes';
import { getMoneyMapsForMembershipQueryKey } from './useGetMoneyMapsForMembership';

export const useRefetchGetMembershipMoneyMapsMutationOptions = (
    membership: MembershipDetails | null,
): CommonMutationOptions => {
    const queryClient = useQueryClient();
    const membershipMoneyMapsQueryKey = getMoneyMapsForMembershipQueryKey({
        membershipId: membership?.id,
    });

    return {
        onMutate: async () => {
            await queryClient.cancelQueries({
                queryKey: [membershipMoneyMapsQueryKey],
                exact: true,
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: [membershipMoneyMapsQueryKey],
                exact: true,
            });
        },
        onSettled: () => {},
    };
};
